import React from 'react';
import { useTranslation } from 'react-i18next';
import './DiscoverWidgetsDrawer.css';

const EXTRA_KEYS = ['alerts', 'saved', 'friends'];

/** Te same kształty co w `Header.js` — kolorystyka nagłówka, animacje w CSS */
function DiscoverWidgetsDrawerColumnsBlobs() {
  return (
    <div className="discover-widgets-drawer-columns-blobs" aria-hidden="true">
      <svg
        className="discover-widgets-drawer-columns-blobs-svg discover-widgets-drawer-columns-blobs-svg--left"
        preserveAspectRatio="xMinYMid slice"
        viewBox="10 10 80 80"
        focusable="false"
      >
        <path
          className="discover-widgets-drawer-columns-blob discover-widgets-drawer-columns-blob--out-top"
          fill="rgba(180, 72, 18, 0.55)"
          d="M37-5C25.1-14.7,5.7-19.1-9.2-10-28.5,1.8-32.7,31.1-19.8,49c15.5,21.5,52.6,22,67.2,2.3C59.4,35,53.7,8.5,37-5Z"
        />
        <path
          className="discover-widgets-drawer-columns-blob discover-widgets-drawer-columns-blob--in-top"
          fill="rgba(255, 214, 170, 0.72)"
          d="M20.6,4.1C11.6,1.5-1.9,2.5-8,11.2-16.3,23.1-8.2,45.6,7.4,50S42.1,38.9,41,24.5C40.2,14.1,29.4,6.6,20.6,4.1Z"
        />
      </svg>
      <svg
        className="discover-widgets-drawer-columns-blobs-svg discover-widgets-drawer-columns-blobs-svg--right"
        preserveAspectRatio="xMaxYMid slice"
        viewBox="10 10 80 80"
        focusable="false"
      >
        <path
          className="discover-widgets-drawer-columns-blob discover-widgets-drawer-columns-blob--out-bottom"
          fill="rgba(232, 141, 46, 0.5)"
          d="M105.9,48.6c-12.4-8.2-29.3-4.8-39.4.8-23.4,12.8-37.7,51.9-19.1,74.1s63.9,15.3,76-5.6c7.6-13.3,1.8-31.1-2.3-43.8C117.6,63.3,114.7,54.3,105.9,48.6Z"
        />
        <path
          className="discover-widgets-drawer-columns-blob discover-widgets-drawer-columns-blob--in-bottom"
          fill="rgba(255, 248, 235, 0.78)"
          d="M102,67.1c-9.6-6.1-22-3.1-29.5,2-15.4,10.7-19.6,37.5-7.6,47.8s35.9,3.9,44.5-12.5C115.5,92.6,113.9,74.6,102,67.1Z"
        />
      </svg>
    </div>
  );
}

function DiscoverWidgetsDrawer({ isOpen, onToggle, children }) {
  const { t } = useTranslation('discover');

  return (
    <aside
      className={`discover-widgets-drawer${isOpen ? ' is-open' : ''}`}
      aria-label={t('discover.drawer.regionLabel')}
    >
      <div className="discover-widgets-drawer-inner">
        <div className="discover-widgets-drawer-panel" id="discover-widgets-drawer-panel">
          <div className="discover-widgets-drawer-columns">
            <DiscoverWidgetsDrawerColumnsBlobs />
            <div className="discover-widgets-drawer-columns-surface">
              <div className="discover-widgets-drawer-main widgets-column">{children}</div>
              <div className="discover-widgets-drawer-extras">
                {EXTRA_KEYS.map((key) => (
                  <div key={key} className="discover-widgets-drawer-extra-tile">
                    <span className="discover-widgets-drawer-extra-title">
                      {t(`discover.drawer.extras.${key}.title`)}
                    </span>
                    <span className="discover-widgets-drawer-extra-sub">
                      {t(`discover.drawer.extras.${key}.subtitle`)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <button
          type="button"
          className={`discover-widgets-drawer-toggle${isOpen ? ' is-open' : ''}`}
          onClick={onToggle}
          aria-expanded={isOpen}
          aria-controls="discover-widgets-drawer-panel"
          id="discover-widgets-drawer-toggle"
          title={t('discover.drawer.toggleTitle')}
          aria-label={t('discover.drawer.toggleAria')}
        >
          <span className="discover-widgets-drawer-toggle-grip" aria-hidden="true">
            <span className="discover-widgets-drawer-toggle-grip-bar" />
            <span className="discover-widgets-drawer-toggle-grip-bar" />
            <span className="discover-widgets-drawer-toggle-grip-bar" />
          </span>
          <span className="discover-widgets-drawer-toggle-badge" aria-hidden="true">
            <span className="discover-widgets-drawer-toggle-icon discover-widgets-drawer-toggle-icon--desktop">
              {isOpen ? '»' : '«'}
            </span>
            <span className="discover-widgets-drawer-toggle-icon discover-widgets-drawer-toggle-icon--mobile">
              {isOpen ? '⌄' : '⌃'}
            </span>
          </span>
          <span className="discover-widgets-drawer-toggle-copy">
            <span className="discover-widgets-drawer-toggle-kicker">
              {t('discover.drawer.handleKicker')}
            </span>
            <span className="discover-widgets-drawer-toggle-text">{t('discover.drawer.handle')}</span>
            <span className="discover-widgets-drawer-toggle-state">
              {isOpen ? t('discover.drawer.handleStateOpen') : t('discover.drawer.handleStateClosed')}
            </span>
          </span>
        </button>
      </div>
    </aside>
  );
}

export default DiscoverWidgetsDrawer;
